import { render, staticRenderFns } from "./EcashPostpayRecord.vue?vue&type=template&id=4e071f42&"
import script from "./EcashPostpayRecord.vue?vue&type=script&lang=js&"
export * from "./EcashPostpayRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports